import { clsx } from 'clsx';
import type { ReactNode } from 'react';

/**
 * Barra de ferramentas de página (agents/skills/ui B.4): grupos à esquerda, espaçador, ação primária no fim.
 * `role="group"` em vez de `toolbar`: a barra tem campo de texto, e a navegação por setas de um toolbar ARIA atrapalharia a digitação.
 */
export function BarraFerramentas({ rotulo, children, className }: { rotulo: string; children: ReactNode; className?: string }) {
  return (
    <div className={clsx('barra-ferramentas', className)} role="group" aria-label={rotulo}>
      {children}
    </div>
  );
}

/** Conjunto de controles relacionados, separados dos vizinhos por espaço (HIG: agrupar por função). */
export function GrupoBarra({ children, rotulo }: { children: ReactNode; rotulo?: string }) {
  return <div className="grupo-barra" role={rotulo ? 'group' : undefined} aria-label={rotulo}>{children}</div>;
}

/** Empurra o que vem depois para o fim da barra. */
export function EspacoBarra() {
  return <span className="espaco-barra" aria-hidden="true" />;
}
